import React, { memo, forwardRef } from "react";
const SvgNthRoot = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M14.08 11.606a1 1 0 01.919-.606h13a1 1 0 110 2h-12.34l-5.74 13.394a1 1 0 01-1.84 0L5.34 20H4a1 1 0 110-2h2a1 1 0 01.92.606l2.08 4.855 5.08-11.855z"
        clipRule="evenodd"
      />
      <rect width={10} height={12} x={17} y={15} fill="#DBDBDB" rx={2} />
      <rect width={8} height={10} x={3} y={6} fill="#DBDBDB" rx={1} />
    </svg>
  );
});
SvgNthRoot.displayName = "SvgNthRoot";
const MemoForwardRef = memo(SvgNthRoot);
export default MemoForwardRef;
